import _async_to_generator from "@swc/helpers/src/_async_to_generator.mjs";
import _ts_generator from "@swc/helpers/src/_ts_generator.mjs";
import axios from "axios";
import { useRouter } from "next/router";
import { useEffect, useState } from "react";
var useHttpClient = function(param) {
    var url = param.url, _method = param.method, method = _method === void 0 ? "get" : _method, _payload = param.payload, payload = _payload === void 0 ? {} : _payload;
    var ref = useState(null), data = ref[0], setData = ref[1];
    var ref1 = useState(""), error = ref1[0], setError = ref1[1];
    var ref2 = useState(false), loaded = ref2[0], setLoaded = ref2[1];
    var router = useRouter();
    // FIXME: potentially error with Node v14
    // const controllerRef = useRef(new AbortController());
    // const cancel = () => {
    //   controllerRef.current.abort();
    // };
    useEffect(function() {
        _async_to_generator(function() {
            var res, err;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            3,
                            4
                        ]);
                        return [
                            4,
                            axios.request({
                                data: payload,
                                // signal: controllerRef.current.signal,
                                method: method,
                                url: url,
                                headers: {
                                    locale: router.locale
                                },
                                withCredentials: true
                            })
                        ];
                    case 1:
                        res = _state.sent();
                        setData(res.data);
                        return [
                            3,
                            4
                        ];
                    case 2:
                        err = _state.sent();
                        setError(err === null || err === void 0 ? void 0 : err.message);
                        return [
                            3,
                            4
                        ];
                    case 3:
                        setLoaded(true);
                        return [
                            7
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        url
    ]);
    return {
        data: data,
        error: error,
        loaded: loaded
    };
};
export { useHttpClient };
